import { useRouter } from "next/router";
import { styled } from "styled-components";
import { useTranslation } from "@pancakeswap/localization";
import {
  ToggleView,
  ViewMode,
  ButtonMenu,
  ButtonMenuItem,
  Toggle,
  Text,
  NotificationDot,
  NextLinkFromReactRouter,
} from "@pancakeswap/uikit";

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: auto;
  }

  ${Text} {
    margin-left: 8px;
  }
`;

const ViewControls = styled.div`
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 100%;
  flex: 1;
  gap: 16px;

  // > div {
  //   padding: 8px 0px;
  // }

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: row;
    justify-content: flex-start;
    width: auto;

    // > div {
    //   padding: 0;
    // }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface PoolTableButtonsPropsType {
  stakedOnly: boolean;
  setStakedOnly: (s: boolean) => void;
  viewMode: ViewMode;
  setViewMode: (s: ViewMode) => void;
  hasStakeInFinishedPools: boolean;
  hideViewMode?: boolean;
}

const PoolTabButtons = ({
  stakedOnly,
  setStakedOnly,
  hasStakeInFinishedPools,
  viewMode,
  setViewMode,
  hideViewMode = false,
}: PoolTableButtonsPropsType) => {
  const router = useRouter();

  const { t } = useTranslation();

  const isLive = router.pathname === "/pools" || router.pathname === "/coinpools";
  const isCoinPools = router.pathname.startsWith("/coinpools")

  const viewModeToggle = hideViewMode ? null : (
    <ToggleView idPrefix="clickPool" viewMode={viewMode} onToggle={setViewMode} />
  );

  const liveOrFinishedSwitch = (
    <Wrapper>
      <ButtonMenu activeIndex={isLive ? 0 : 1} scale="sm" variant="primary">
        <ButtonMenuItem as={NextLinkFromReactRouter} to={isCoinPools ? "/coinpools" : "/pools"} replace style={{ fontSize: "14px" }}>
          {t("Live")}
        </ButtonMenuItem>
        <NotificationDot show={hasStakeInFinishedPools}>
          <ButtonMenuItem id="finished-pools-button" as={NextLinkFromReactRouter} to={ isCoinPools ? "/coinpools/history" : "/pools/history" } style={{ fontSize: "14px" }} replace>
            {t("Finished")}
          </ButtonMenuItem>
        </NotificationDot>
      </ButtonMenu>
    </Wrapper>
  );

  const stakedOnlySwitch = (
    <ToggleWrapper>
      <Toggle checked={stakedOnly} onChange={() => setStakedOnly(!stakedOnly)} scale="sm" />
      <Text fontSize={14}> {t(stakedOnly ? "Staked only" : "All pools")}</Text>
    </ToggleWrapper>
  );

  return (
    <ViewControls>
      {viewModeToggle}
      {liveOrFinishedSwitch}
      {stakedOnlySwitch}
    </ViewControls>
  );
};

export default PoolTabButtons;
